<template>
  <div
    class="cp-media-modal"
  >
    <div class="layer" />
    <div class="modal-container video">
      <div
        class="video-wrapper"
      >
        <slot />
        <button
          @click="onCloseModalVideo"
          type="button"
          class="btn-close"
        >
          <svg class="icon icon-close-modal">
            <use xlink:href="#icon-close-modal"></use>
          </svg>
        </button>
        <div
          class="modal-content"
        >
          <youtube
            :video-id="idYoutube"
            ref="youtube"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Youtube } from 'vue-youtube';

export default {
  components: {
    Youtube,
  },
  props: {
    idYoutube: {
      type: String,
      required: true,
    },
  },
  methods: {
    onCloseModalVideo() {
      this.$emit('close-modal-video');
    },
  },
}
</script>
